export const FETCH_POLLS_REQUEST = 'FETCH_POLLS_REQUEST'
export const FETCH_POLLS_SUCCESS = 'FETCH_POLLS_SUCCESS'
export const FETCH_POLLS_FAIL = 'FETCH_POLLS_FAIL'

export const SAVE_POLL_REQUEST = 'SAVE_POLL_REQUEST'
export const SAVE_POLL_SUCCESS = 'SAVE_POLL_SUCCESS'
export const SAVE_POLL_FAIL = 'SAVE_POLL_FAIL'

export const CHANGE_ANSWER = 'CHANGE_ANSWER'
export const ADD_ANSWER_GROUP = 'ADD_ANSWER_GROUP'
export const DELETE_ANSWER_GROUP = 'DELETE_ANSWER_GROUP'
export const MARK_CORRECT_ANSWER_GROUP = 'MARK_CORRECT_ANSWER_GROUP'

export const DELETE_POLL_REQUEST = 'DELETE_POLL_REQUEST'
export const DELETE_POLL_SUCCESS = 'DELETE_POLL_SUCCESS'
export const DELETE_POLL_FAIL = 'DELETE_POLL_FAIL'

export const CHANGE_POLL_TYPE = 'CHANGE_POLL_TYPE'
export const LOAD_POLL = 'LOAD_POLL'

export const PUBLISH_POLL = 'PUBLISH_POLL'
export const UNPUBLISH_POLL = 'UNPUBLISH_POLL'

export const SORT_POLL_TYPE_CHANGE = 'SORT_POLL_TYPE_CHANGE'
export const CLEAR_POLL_STATE = 'CLEAR_POLL_STATE'
export const SEARCH_POLL = 'SEARCH_POLL'

export const CHANGE_POLL_PAGE = 'CHANGE_POLL_PAGE'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'
export const DISABLE_POLL_TYPE_CHANGE = 'DISABLE_POLL_TYPE_CHANGE'
export const FILTER_POLL_CHANGE = 'FILTER_POLL_CHANGE'
